/// <amd-module name="Wit/Clients/TemporaryData/RestClient/TemporaryData" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\core\clientgeneratorconfigs\temporarydata\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as TemporaryData from "../Contracts/TemporaryData";

export interface ITemporaryDataRestClient extends IVssRestClient {
    /**
     * Create a new temporary data with the provided guid
     * 
     * @param requestBody - The data of temporary artifact in json format.
     * @param id - New temporary data Id
     */
    createTemporaryData(requestBody: TemporaryData.TemporaryDataDTO, id?: string): Promise<TemporaryData.TemporaryDataCreatedDTO>;
    /**
     * Get a temporary artifact.
     * 
     * @param id - The ID of the temporary artifact.
     */
    getTemporaryData(id: string): Promise<TemporaryData.TemporaryDataCreatedDTO>;
}

class TemporaryDataRestClient extends RestClientBase implements ITemporaryDataRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a new temporary data with the provided guid
     * 
     * @param requestBody - The data of temporary artifact in json format.
     * @param id - New temporary data Id
     */
    public async createTemporaryData(
        requestBody: TemporaryData.TemporaryDataDTO,
        id?: string
        ): Promise<TemporaryData.TemporaryDataCreatedDTO> {

        return this.beginRequest<TemporaryData.TemporaryDataCreatedDTO>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/properties/{id}",
            routeValues: {
                id: id
            },
            body: requestBody
        });
    }

    /**
     * Get a temporary artifact.
     * 
     * @param id - The ID of the temporary artifact.
     */
    public async getTemporaryData(
        id: string
        ): Promise<TemporaryData.TemporaryDataCreatedDTO> {

        return this.beginRequest<TemporaryData.TemporaryDataCreatedDTO>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/properties/{id}",
            routeValues: {
                id: id
            }
        });
    }

}

export const TemporaryDataClientName = "TemporaryData.ITemporaryDataRestClient";

export function getTemporaryDataClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITemporaryDataRestClient {
    return pageContext.getRestClient<ITemporaryDataRestClient>(TemporaryDataClientName, options);
}

RestClients.add(TemporaryDataClientName, { 
    factory: TemporaryDataRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
